module.exports = __webpack_public_path__ + "img/dr_wisniewska.1f6d3c1f.jpg";